import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../actions/trackingDataActions';
import * as dialogPopupActions from '../actions/dialogPopupActions';
import * as appHelper from '../helpers/appHelper';
import * as appConstants from '../constants/appConstants';
import * as scormConstants from '../constants/scormConstants';
import * as localStorage from '../localStorage/localStorage';
import * as keyboardConstants from '../constants/keyboardConstants';
import * as objectConstants from '../constants/objectConstants';

class AppFooter extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            trackingData: props.trackingData,
            last_lesson_location: props.last_lesson_location,
            next_lesson_location: props.next_lesson_location,
            enable_next: props.enable_next,
            show_footer_navigation: props.show_footer_navigation,
            locale: {},
            assets: {
                logo: {
                    src: "",
                }
            },
            setLocale: false,
            back_label: appHelper.getLocaleString("back_label"),
            next_label: appHelper.getLocaleString("next_label"),
            include_back_and_next: false,

        };
        this.getLocale = this.getLocale.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getPreviousScreen = this.getPreviousScreen.bind(this);
        this.getPreviousBtnClass = this.getPreviousBtnClass.bind(this);
        this.isBackEnabled = this.isBackEnabled.bind(this);
        this.keyboardGetPreviousScreen = this.keyboardGetPreviousScreen.bind(this);
        this.getNextScreen = this.getNextScreen.bind(this);
        this.keyboardGetNextScreen = this.keyboardGetNextScreen.bind(this);

        this.getNextBtnClass = this.getNextBtnClass.bind(this);

    }



    componentDidMount() {
        this.getLocale();
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                back_label: appHelper.getLocaleString("back_label"),
                next_label: appHelper.getLocaleString("next_label"),
                setLocale: true
            });
        }

        if(this.state.trackingData !== nextProps.trackingData){
            this.setState({
                trackingData: Object.assign({},nextProps.trackingData),
                setLocale: true
            });
        }

        if(this.state.last_lesson_location !== nextProps.last_lesson_location){
            this.setState({last_lesson_location: nextProps.last_lesson_location});
        }

        if(this.state.next_lesson_location !== nextProps.next_lesson_location){
            this.setState({next_lesson_location: nextProps.next_lesson_location});
        }

        if(this.state.enable_next !== nextProps.enable_next){
            this.setState({enable_next: nextProps.enable_next});
        }

        if(this.state.show_footer_navigation !== nextProps.show_footer_navigation){
            this.setState({show_footer_navigation: nextProps.show_footer_navigation});
        }
    }

    componentDidUpdate(){
        if(this.state.setLocale){
            this.getLocale();
        }

    }

    getLocale() {
        let locale = appHelper.getLocalData(this.props.contentData.experience);
        this.setState({locale: Object.assign({}, locale), setLocale: false});
    }

    getAssets() {

        let logoAsset = appHelper.getFooterLogoAsset(this.props.contentData.experience.footer_logo);
        if(appHelper.isDefined(logoAsset)) {
            this.setState({
                assets: Object.assign({}, this.state.assets, {
                    logo: logoAsset
                })
            });
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if(appHelper.isDefined(image) && image.length > 0) {
                return require(`../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    isBackEnabled(){
        let screen_id = this.state.trackingData.lesson_location;
        let bite_id = appHelper.getBiteByScreenId(screen_id);
        let bite = appHelper.getBiteById(bite_id);
        let biteIndex = appHelper.getArrayObjectIndexByKey(this.props.contentData.experience.bites,"bite_id",bite_id);
        let screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens,"screen_id",screen_id);

        return this.state.last_lesson_location !== 0 && screenIndex !== 0;
    }

    getPreviousScreen(){
        let screen_id = this.state.trackingData.lesson_location;
        let bite_id = appHelper.getBiteByScreenId(screen_id);
        let bite = appHelper.getBiteById(bite_id);
        let screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens,"screen_id",screen_id);

        if(this.isBackEnabled()){
            this.props.actions.removeScreenDialog();
            if(screenIndex === 0){
                this.context.router.push('menu');
            }else{
                this.props.actions.setNewLessonLocation(this.state.last_lesson_location);
            }

        }
    }

    keyboardGetPreviousScreen(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getPreviousScreen();
        }
    }

    getNextScreen(){
        let screen_id = this.state.trackingData.lesson_location;
        let bite_id = appHelper.getBiteByScreenId(screen_id);
        let isOpenNavigation = appHelper.getBiteById(bite_id).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN;
        if(this.state.enable_next) {
            this.props.actions.removeScreenDialog();
            if (this.state.next_lesson_location === -1) {
                this.context.router.push('menu');
            } else {
                this.props.actions.setNewLessonLocation(this.state.next_lesson_location);
            }
        }
    }

    keyboardGetNextScreen(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getNextScreen();
        }
    }

    getPreviousBtnClass(){
        return !this.isBackEnabled() ? "disabled" : "";
    }

    getNextBtnClass(){
        let screen_id = this.state.trackingData.lesson_location;
        let bite_id = appHelper.getBiteByScreenId(screen_id);
        let isOpenNavigation = appHelper.getBiteById(bite_id).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN;
        return !this.state.enable_next ? "disabled" : "";
    }

    render() {
        return (
            <div className="footer">

                <div className="flex-row-nowrap flex-align-items-center">
                    <div className="flex-1">
                        <div className="footer-logo-container">
                            {
                                appHelper.isDefined(this.state.assets.logo) && this.state.assets.logo.src.length > 0
                                    ?
                                    <img src={this.getImagePath(this.state.assets.logo.src)} alt=""/>
                                    :
                                    null
                            }

                        </div>
                    </div>
                    <div className="flex-3 ">
                        <div className="footer-text text-center flex-row-nowrap flex-justify-content-center">
                            {
                                appHelper.isDefined(this.state.locale.footer_text)
                                    ?
                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.footer_text}}/>
                                    :
                                    null
                            }
                            {appHelper.isDefined(this.props.contentData.experience.is_preview) && this.props.contentData.experience.is_preview
                            &&

                                <div><p>&nbsp; -  Suspend Data: {JSON.stringify(this.state.trackingData.suspend_data).length} / {scormConstants.SUSPEND_DATA_LIMIT}</p></div>

                            }
                        </div>
                    </div>
                    <div className="flex-1">
                        {this.props.contentData.experience.include_back_and_next && this.state.trackingData.initialised && this.state.show_footer_navigation
                            ?
                            <div className="footer-text text-right">
                                <ul className="footer-nav">
                                    <li className={`footer-nav-item ${this.getPreviousBtnClass()}`}
                                        role="presentation">
                                        <div className="footer-back-btn" role="link" tabIndex="0"
                                             onClick={this.getPreviousScreen}
                                             onKeyDown={this.keyboardGetPreviousScreen}>
                                            {this.state.back_label}
                                        </div>
                                    </li>
                                    <li className={`footer-nav-item ${this.getNextBtnClass()}`} role="presentation">
                                        <div className="footer-next-btn" role="link" tabIndex="0"
                                             onClick={this.getNextScreen} onKeyDown={this.keyboardGetNextScreen}>
                                            {this.state.next_label}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            :
                           null
                        }
                    </div>
                </div>

            </div>
        );
    }
}

AppFooter.propTypes = {
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    last_lesson_location: PropTypes.number.isRequired,
    next_lesson_location: PropTypes.number.isRequired,
    enable_next: PropTypes.bool.isRequired,
    show_footer_navigation: PropTypes.bool.isRequired,
    lang: PropTypes.string,
    actions: PropTypes.object.isRequired
};

AppFooter.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        contentData: state.contentData,
        last_lesson_location: state.trackingData.last_lesson_location,
        next_lesson_location: typeof state.trackingData.next_lesson_location !== "number" ? 0 : state.trackingData.next_lesson_location,
        enable_next:  state.trackingData.enable_next,
        show_footer_navigation:  state.trackingData.show_footer_navigation,
        trackingData: state.trackingData,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},trackingDataActions,dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(AppFooter);



/** WEBPACK FOOTER **
 ** ./src/components/AppFooter.js
 **/